<!-- LegalPage.vue - Impressum and Datenschutzerklärung in the article layout. Texts in locales/<lang>/legal.json,
     operator data from .env (VUE_APP_OPERATOR_*). Draft: have it checked by a lawyer before launch. -->
<template>
  <ArticleLayout
    :eyebrow="$t('legal.eyebrow')"
    :title="$t(`legal.${kind}.title`)"
    :as-of="kind === 'privacy' ? $t('legal.privacy.asOf', { date: op.privacyDate || $t('legal.todo') }) : ''"
    :lead="kind === 'privacy' ? $t('legal.privacy.lead') : ''"
    :reading-minutes="kind === 'privacy' ? 4 : 0"
    :sections="sections"
  >
    <template v-if="kind === 'imprint'">
      <section id="provider">
        <h2>{{ $t('legal.imprint.providerTitle') }}</h2>
        <address>
          <span v-if="op.name">{{ op.name }}</span><span v-else class="todo">{{ $t('legal.todo') }}</span><br />
          <template v-for="(line, i) in op.address" :key="i">{{ line }}<br /></template>
          <span v-if="!op.address.length" class="todo">{{ $t('legal.todo') }}</span>
        </address>
      </section>
      <section id="contact">
        <h2>{{ $t('legal.imprint.contactTitle') }}</h2>
        <p>
          {{ $t('legal.imprint.email') }}
          <a v-if="op.email" :href="'mailto:' + op.email">{{ op.email }}</a><span v-else class="todo">{{ $t('legal.todo') }}</span>
          <template v-if="op.phone"><br />{{ $t('legal.imprint.phone') }} {{ op.phone }}</template>
        </p>
      </section>
      <section id="responsible">
        <h2>{{ $t('legal.imprint.responsibleTitle') }}</h2>
        <p>{{ op.responsible || op.name }}<span v-if="!op.responsible && !op.name" class="todo">{{ $t('legal.todo') }}</span></p>
      </section>
      <section id="dispute">
        <h2>{{ $t('legal.imprint.disputeTitle') }}</h2>
        <p>{{ $t('legal.imprint.disputeText') }}</p>
      </section>
    </template>

    <template v-else>
      <section v-for="s in privacySections" :id="s" :key="s">
        <h2>{{ $t(`legal.privacy.${s}.title`) }}</h2>
        <p v-if="s === 'controller'">
          <span v-if="op.name">{{ op.name }}</span><span v-else class="todo">{{ $t('legal.todo') }}</span><br />
          <template v-for="(line, i) in op.address" :key="i">{{ line }}<br /></template>
          <a v-if="op.email" :href="'mailto:' + op.email">{{ op.email }}</a>
        </p>
        <p v-else>{{ $t(`legal.privacy.${s}.text`, { hosting: op.hosting || $t('legal.todo') }) }}</p>
      </section>
    </template>

    <template v-if="op.email" #contact>
      <div class="contact-text">
        <h2>{{ $t('legal.contactTitle') }}</h2>
        <p>{{ $t('legal.contactText') }}</p>
      </div>
      <a class="btn-standard" :href="'mailto:' + op.email">{{ $t('legal.contactButton') }}</a>
    </template>
  </ArticleLayout>
</template>

<script>
import ArticleLayout from '@/components/ArticleLayout.vue';

const env = (k) => (process.env[k] || '').trim();
const PRIVACY = ['controller', 'data', 'reports', 'ai', 'maps', 'account', 'hosting', 'storage', 'device', 'rights'];
const IMPRINT = ['provider', 'contact', 'responsible', 'dispute'];
const IMPRINT_TITLES = { provider: 'providerTitle', contact: 'contactTitle', responsible: 'responsibleTitle', dispute: 'disputeTitle' };

export default {
  name: 'LegalPage',
  components: { ArticleLayout },
  props: { kind: { type: String, required: true } }, // 'imprint' | 'privacy'
  data() {
    return {
      op: {
        name: env('VUE_APP_OPERATOR_NAME'),
        address: env('VUE_APP_OPERATOR_ADDRESS').split('|').map((l) => l.trim()).filter(Boolean), // lines separated by |
        email: env('VUE_APP_OPERATOR_EMAIL'),
        phone: env('VUE_APP_OPERATOR_PHONE'),
        responsible: env('VUE_APP_OPERATOR_RESPONSIBLE'),
        hosting: env('VUE_APP_HOSTING_PROVIDER'),
        privacyDate: env('VUE_APP_PRIVACY_DATE'),
      },
      privacySections: PRIVACY,
    };
  },
  computed: {
    sections() {
      return this.kind === 'privacy'
        ? PRIVACY.map((s) => ({ id: s, title: this.$t(`legal.privacy.${s}.title`) }))
        : IMPRINT.map((s) => ({ id: s, title: this.$t(`legal.imprint.${IMPRINT_TITLES[s]}`) }));
    },
  },
};
</script>

<style scoped>
address { font-style: normal; }
.todo { font-style: italic; color: var(--color-error-text, #b00020); }
.contact-text { flex: 1 1 260px; }
.btn-standard { display: inline-flex; align-items: center; text-decoration: none !important; color: var(--color-text) !important; }
</style>
